import React from 'react'

// general imports
import { IconPropsType } from '../types'

const EyeIcon = ({ className }: IconPropsType) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='14'
      height='10'
      viewBox='0 0 14 10'
      fill='none'
      className={className}
    >
      <path
        d='M13.4326 6.643H13.4354H13.4297H13.4326ZM13.0297 6.34585C13.0868 6.52757 13.2514 6.64185 13.4326 6.643C13.4726 6.643 13.5166 6.63157 13.5611 6.62014C13.784 6.55157 13.9097 6.30585 13.8354 6.083C13.8183 6.03157 12.104 0.928711 6.99998 0.928711C1.89598 0.928711 0.181126 6.03157 0.163983 6.083C0.0896974 6.30585 0.215412 6.54585 0.438269 6.62014C0.66684 6.69443 0.90684 6.56871 0.981126 6.34585L0.98284 6.343C1.05884 6.12014 2.54684 1.78585 7.0057 1.78585C11.4868 1.78585 12.9668 6.15728 13.0297 6.34585ZM4.14284 6.643C4.14284 5.88523 4.44386 5.15851 4.97968 4.62269C5.5155 4.08687 6.24222 3.78585 6.99998 3.78585C7.75774 3.78585 8.48447 4.08687 9.02029 4.62269C9.55611 5.15851 9.85713 5.88523 9.85713 6.643C9.85713 7.40076 9.55611 8.12748 9.02029 8.6633C8.48447 9.19912 7.75774 9.50014 6.99998 9.50014C6.24222 9.50014 5.5155 9.19912 4.97968 8.6633C4.44386 8.12748 4.14284 7.40076 4.14284 6.643Z'
        fill='white'
      />
    </svg>
  )
}

export default EyeIcon
